import {SOURCE_DATA_MAP} from '../constants/sources';

/**
 * Génère et déclenche le téléchargement d'un fichier CSV à partir des données
 * agrégées par groupe de bâtiment.
 * @param {Object} csvData   - map { batiment_groupe_id → { batiments, dpes, … } }
 * @param {Object} colons    - métadonnées de colonnes par source
 * @param {string} separator - séparateur CSV (';', ',', '\t', '|')
 */
export function exportToCsv(csvData, colons, separator) {
    const sep = separator === '\\t' ? '\t' : separator;

    const esc = v => {
        const s = String(v ?? '');
        return (s.includes(sep) || s.includes('"') || s.includes('\n'))
            ? `"${s.replace(/"/g, '""')}"` : s;
    };

    const allHeaders = [
        'batiment_groupe_id',
        ...Object.entries(colons).flatMap(([src, meta]) =>
            Object.keys(meta).map(col => `${src}.${col}`)
        ),
    ];

    const allRows = Object.entries(csvData).map(([bgId, entry]) => {
        const row = {batiment_groupe_id: bgId};
        Object.entries(colons).forEach(([src, meta]) => {
            const items = SOURCE_DATA_MAP[src]?.(entry) || [];
            Object.keys(meta).forEach(col => {
                row[`${src}.${col}`] = items.map(it => it[col] ?? '').filter(Boolean).join(' | ');
            });
        });
        return row;
    });

    const lines = [
        allHeaders.map(esc).join(sep),
        ...allRows.map(row => allHeaders.map(h => esc(row[h] ?? '')).join(sep)),
    ];

    const url = URL.createObjectURL(new Blob([lines.join('\n')], {type: 'text/csv;charset=utf-8'}));
    const link = Object.assign(document.createElement('a'), {
        href: url,
        download: `export-${new Date().toISOString().replace(/[:.]/g, '-')}.csv`,
    });
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
}

